export default __webpack_public_path__ + "static/media/logo.6cf5306e.svg";